import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'
import PoziMap from 'map/map'

import * as LayerActions from '../actions'

const CURRENT_LEVEL_KEY = 'app.config.currentLevel'

export function getCurrentLevel () {
  return Model.get(CURRENT_LEVEL_KEY, undefined)
}

export function setCurrentLevel (layer) {
  Model.set(CURRENT_LEVEL_KEY, layer)
}

/**
 * update the filter of any visible layer that has the autoFilterOnLevel property
 */
export function applyAutoFilterToVisibleLayers (newCurrentLevel) {
  Object.entries(Model.get('app.config.layerbytitleid', {})) // convert obj to array
    .filter(([key, value]) => value.visible) // keep visible layers
    .map(([key, value]) => PoziUtils.getLayerFromTitleID(key)) // get the full layer
    .filter(otherLayer => 'autoFilterOnLevel' in otherLayer) // has autoFilterOnLevel prop
    .forEach(otherLayer => applyAutoFilterOnLevel(otherLayer, newCurrentLevel))
}

/**
 * Set a layer's filter to be the currentLevel
 *
 * @param {layer object} layer
 * @param {layer object} currentLevel
 */
export function applyAutoFilterOnLevel (layer, currentLevel) {
  const filterProp = layer.autoFilterOnLevel.prop
  const filterValue = currentLevel[layer.autoFilterOnLevel.value]

  // Note. this dispatch only sets the layer-panel UI state, it does not
  // apply the filter to the map
  window.store.dispatch(
    LayerActions.setLayerFilter(layer.titleid, {
      prop: filterProp,
      value: filterValue
    })
  )

  // apply the filter to the map, but first make sure the layer has finished
  // loading.
  const key = 'app.config.layerbytitleid[' + layer.titleid + '].loaded'
  const isLayerLoaded = Model.get(key, false)
  if (isLayerLoaded) {
    PoziMap().showFeaturesInLayer(layer, filterProp, filterValue)
  } else {
    Model.on(key, () => PoziMap().showFeaturesInLayer(layer, filterProp, filterValue))
  }
}
